import Heading from '@amzn/meridian/heading';
import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import { TEXT_TYPE, KEY_TERM_TYPE, IMAGE_TYPE, VIDEO_TYPE, LINK_TYPE} from '../../constants/common';
import TextContent from './TextContent';
import KeyTermContent from './KeyTermContent';
import ImageContent from './ImageContent';
import VideoContent from './VideoContent';
import LinkContent from './LinkContent';

interface ContentRendererProps {
  title: string;
  content: Array<string> | string;
  contentType: string;
  onDownloadBtnClick: (value: string) => void;
}

const ContentRenderer: React.FC<ContentRendererProps> = ({title, content, contentType, onDownloadBtnClick}) => {

  const contentRenderers: { [key: string]: React.JSX.Element }  = {
    [TEXT_TYPE]: <TextContent content={content} />,
    [KEY_TERM_TYPE]: <KeyTermContent content={content} />,
    [IMAGE_TYPE]: <ImageContent content={content} />,
    [VIDEO_TYPE]: <VideoContent content={content} />,
    [LINK_TYPE]: <LinkContent content={content} onDownloadBtnClick={onDownloadBtnClick} />,
  };

  return (
    <Column spacing='small'>
      <Row>
        <Heading level={2}>{title}</Heading>
      </Row>
      <Row>
        {contentRenderers[contentType]}
      </Row>
    </Column>
  );
};

export default ContentRenderer;